export default __webpack_public_path__ + "../img/1df4ce5f9eb0d5e9e0f0285118c8cd96.png";